import { ListItem, UnorderedList, useDisclosure } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import {
  CmButton,
  CmModal,
  CmModalBody,
  CmModalFooter,
  CmText,
  CmTooltip,
} from '@/components/uiParts';

interface Props {
  accountName: string;
  storeNames: string[];
}

export const MemberDetailModal: React.FC<Props> = ({
  accountName,
  storeNames,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const storeNameLabel = useMemo(() => {
    return storeNames.join(', ');
  }, [storeNames]);

  return (
    <>
      <CmTooltip label={storeNameLabel} wordBreak="break-all">
        {storeNames.length < 2 ? (
          <CmText>{storeNames}</CmText>
        ) : (
          // @ts-ignore TS2590
          <CmButton
            onClick={onOpen}
            variant="link"
            colorScheme="black"
            fontWeight="normal"
          >
            <CmText maxWidth="200px" isTruncated>
              {storeNames[0]}
            </CmText>
            <CmText fontSize="xs" pl={4}>
              ...もっと見る
            </CmText>
          </CmButton>
        )}
      </CmTooltip>
      <CmModal
        title={`${accountName}さん の担当店舗`}
        headerSize="md"
        size="lg"
        {...{ isOpen, onClose }}
      >
        <CmModalBody>
          <UnorderedList>
            {storeNames.map((storeName, i) => (
              <ListItem wordBreak="break-all" mb={2} key={i}>
                {storeName}
              </ListItem>
            ))}
          </UnorderedList>
        </CmModalBody>
        <CmModalFooter>
          <CmButton onClick={onClose} variant="outline">
            閉じる
          </CmButton>
        </CmModalFooter>
      </CmModal>
    </>
  );
};
